import * as React from 'react';
import { Alert, Row, Col, NavItem, Nav, NavLink, TabContent, TabPane, ToastBody, ToastHeader, Toast } from 'reactstrap';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { Afr, existFactsInTable, generateLocalStateFromEventProperties, getSelectedAfr } from '../../redux/AfrSlice';
import enums from '../../utils/enums';
import UploadDocumentByRole from '../feature/UploadDocumentByRole';
import { useState, useEffect } from 'react';
import utilityHelper from '../../utils/utilityHelper';
import { RowDimensionEditorGrid } from '../core/RowDimensionEditorGrid';
import { RowConceptAndDimensionEditorGrid } from '../core/RowConceptAndDimensionEditorGrid';
import { ConceptNode } from '../../redux/AccountsSlice';
import { getSelectedTitles, getTitleValue } from '../../redux/TitleSlice';
import SupplementalEditorGrid from '../core/SupplementalEditorGrid';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { RowDimensionNoDataCheckBox } from '../core/RowDimensionNoDataCheckBox';


const SupplementalInformationForIndependent = (props: any) => {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const dispatch = useAppDispatch();

    var style = "supplementalDetail";
    var title = "Supplemental Information for Independently Reported Entity";
    const titleConcepts: ConceptNode[] | null = useAppSelector(getSelectedTitles);
    const [compensationTitle, setCompensationTitle] = useState<string[]>([]);
    const [projectsTitle, setProjectsTitle] = useState<string[]>([]);
    const [bondTitle, setBondTitle] = useState<string[]>([]);
    const [millageTitle, setMillageTitle] = useState<string[]>([]);
    const [specialAssessmentTitle, setSpecialAssessmentTitle] = useState<string[]>([]);

    const fetchNoData = function () {
        var newState: any = generateLocalStateFromEventProperties(currentAfr, ["workState_noConstructionProjects", "workState_noBonds"]);
        return newState;
    }
    const [noData, setNoData] = useState<any>(fetchNoData());

    const getNoData = function () {
        return noData;
    }
    const updateNoData = function (newState: any) {
        ["workState_noConstructionProjects", "workState_noBonds"].map((s: string) => {
            if (newState[s] !== noData[s]) {
                setNoData(newState);                
            }
        });
    }
    /* Tabs logic */
    const [activeTab, setActiveTab] = useState("1");
    const fetchFactState = function (): any {
        var fstate: any = {};
        if (currentAfr) {
            ["uas_064_projects", "uas_068_bonds"].map((tblName: string) => {
                fstate[tblName] = existFactsInTable(currentAfr, [tblName]);
            });
        }
        return fstate;
    }
    const [hasFacts, setHasFacts] = useState(fetchFactState());
    const [hasFactsGrid, setHasFactsGrid] = useState(true);

    const updateHasFacts = function (newState: any) {
        console.log("update", newState);
        var newHF = { ...hasFacts };

        ["uas_064_projects", "uas_068_bonds"].map((s: string) => {
            if (newState.hasOwnProperty(s)) {
                newHF[s] = newState[s];
            }
        });
        console.log("hf", newHF);
        setHasFacts(newHF);
    }
    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }

    useEffect(() => {

        // save all the pending changes into AFRSlice
        utilityHelper.saveDeferredChanges(dispatch);

    }, [activeTab]);

    useEffect(() => {
        // get state from redux
        setCompensationTitle(getTitleValue("CompensationTitle", titleConcepts));
        setProjectsTitle(getTitleValue("ProjectsTitle", titleConcepts));
        setBondTitle(getTitleValue("BondsTitle", titleConcepts));
        setMillageTitle(getTitleValue("MillageRatesTitle", titleConcepts));
        setSpecialAssessmentTitle(getTitleValue("SpecialAssessmentRatesTitle", titleConcepts));
    }, [titleConcepts, currentAfr])

    useEffect(() => {
        // get state from redux
        setHasFacts(fetchFactState());
    }, [noData, currentAfr])

    /* ********************************************** */
    return (
        <React.Fragment>

            <Toast className={style}>
                <ToastHeader className={style}>{title}</ToastHeader>
                <ToastBody className={style}>
                    <Row>
                        <Col>
                            <>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('1')}
                                            onClick={() => { toggle('1'); }}
                                        >
                                            <b>Compensation</b>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('2')}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            <b>Construction Projects</b>
                                        </NavLink>
                                    </NavItem>
                                    {utilityHelper.showRatesAndBonds(props.entity) ?
                                        (<React.Fragment>
                                            <NavItem>
                                                <NavLink
                                                    className={activeClass('3')}
                                                    onClick={() => { toggle('3'); }}
                                                >
                                                    <b>Millage Rates</b>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={activeClass('4')}
                                                    onClick={() => { toggle('4'); }}
                                                >
                                                    <b>Special Assessments</b>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={activeClass('5')}
                                                    onClick={() => { toggle('5'); }}
                                                >
                                                    <b>Bonds</b>
                                                </NavLink>
                                            </NavItem>
                                        </React.Fragment>) : (<></>)}
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col>
                                                <h5 style={{ marginTop: "1em" }}>
                                                    {compensationTitle.map((option: string, idx) => (
                                                        <div key={"comp" + idx} dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                                    ))}
                                                </h5>
                                                <SupplementalEditorGrid
                                                    tableName="uas_065_compensation"
                                                    affiliateCode=""
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={{}}
                                                    gridId={"independentCompensation"}
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col >
                                                <h5 style={{ marginTop: "1em" }}>
                                                    {projectsTitle.map((option: string, idx) => (
                                                        <div key={"projects" + idx} dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                                    ))}
                                                </h5>
                                                <RowDimensionNoDataCheckBox
                                                    componentTitle="Construction Projects"
                                                    tableName="uas_064_projects"
                                                    affiliateCode=""
                                                    noDataState="workState_noConstructionProjects"
                                                    gridId={"independentConstructionCB"}
                                                    taxonomyType={TaxonomyTypeEnum.AFR}
                                                    hasFacts={hasFacts["uas_064_projects"]}
                                                    noData={noData}
                                                    updateNoData={updateNoData}
                                                />
                                                <RowDimensionEditorGrid
                                                    componentTitle="Construction Projects"
                                                    tableName="uas_064_projects"
                                                    affiliateCode=""
                                                    noDataState="workState_noConstructionProjects"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={{}}
                                                    gridId={"independentConstruction"}
                                                    dimensionFilter={[]}
                                                    taxonomyType={TaxonomyTypeEnum.AFR}
                                                    noData={noData}
                                                    updateHasFacts={updateHasFacts}
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    {utilityHelper.showRatesAndBonds(props.entity) ?
                                        (<React.Fragment> <TabPane tabId="3">
                                            <Row>
                                                <Col>
                                                    <h5 style={{ marginTop: "1em" }}>
                                                        {millageTitle.map((option: string, idx) => (
                                                            <div key={"millage" + idx} dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                                        ))}
                                                        <Alert color="warning">
                                                            <p>Note: When inputting financial information, you may be unable to click out of the cell if the information is invalid.<br></br>Press <b>escape</b> to cancel editing.</p>
                                                        </Alert>
                                                    </h5>
                                                    <RowConceptAndDimensionEditorGrid
                                                        tableName="uas_066_millage-rates"
                                                        gridData={[]}
                                                        gridColumns={[]}
                                                        gridOptions={{}}
                                                        gridId={"independentMillateRate"}
                                                    />
                                                </Col>
                                            </Row>
                                        </TabPane>
                                            <TabPane tabId="4">
                                                <Row>
                                                    <Col>
                                                        <h5 style={{ marginTop: "1em" }}>
                                                            {specialAssessmentTitle.map((option: string, idx) => (
                                                                <div key={"special" + idx} dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                                            ))}
                                                            <Alert color="warning">
                                                                <p>Note: When inputting financial information, you may be unable to click out of the cell if the information is invalid.<br></br>Press <b>escape</b> to cancel editing.</p>
                                                            </Alert>
                                                        </h5>
                                                        <RowConceptAndDimensionEditorGrid
                                                            tableName="uas_067_special-assessment-rates"
                                                            gridData={[]}
                                                            gridColumns={[]}
                                                            gridOptions={{}}
                                                            gridId={"independentSpecialAssessmentRate"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="5">
                                                <Row>
                                                    <Col>
                                                        <h5 style={{ marginTop: "1em" }}>
                                                            {bondTitle.map((option: string, idx) => (
                                                                <div key={"bond" + idx} dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                                            ))}
                                                            <Alert color="warning">
                                                                <p>Note: When inputting financial information, you may be unable to click out of the cell if the information is invalid.<br></br>Press <b>escape</b> to cancel editing.</p>
                                                            </Alert>
                                                        </h5>
                                                        <RowDimensionNoDataCheckBox
                                                            componentTitle="Bonds"
                                                            tableName="uas_068_bonds"
                                                            affiliateCode=""
                                                            noDataState="workState_noBonds"
                                                            gridId={"independentBondsCB"}
                                                            taxonomyType={TaxonomyTypeEnum.AFR}
                                                            hasFacts={hasFacts["uas_068_bonds"]}
                                                            noData={noData}
                                                            updateNoData={updateNoData}
                                                        />
                                                        <RowDimensionEditorGrid
                                                            componentTitle = "Bonds"
                                                            tableName="uas_068_bonds"
                                                            affiliateCode=""
                                                            noDataState="workState_noBonds"
                                                            gridData={[]}
                                                            gridColumns={[]}
                                                            gridOptions={{}}
                                                            gridId={"independentBonds"}
                                                            dimensionFilter={[]}
                                                            taxonomyType={TaxonomyTypeEnum.AFR}
                                                            noData={noData}
                                                            updateHasFacts={updateHasFacts}
                                                        />
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        </React.Fragment>)
                                        : (<></>)}
                                </TabContent>
                            </>
                        </Col>
                    </Row>

                </ToastBody>
            </Toast>

        </React.Fragment>
    );
}

export default SupplementalInformationForIndependent;